// GENERATED by scripts/build-icons.mjs from icons/panels-top-left.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const PanelsTopLeft = createIcon('panels-top-left', [
  ['rect', { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
  ['path', { d: "M3 9h18" }],
  ['path', { d: "M9 21V9" }],
])
